import { styled } from "styled-components";

export const HomeFont = styled.span`
  font-size: 12px;
  line-height: 13px;
`;
